import { PageShell, Block } from "./PageShell";
import { CRISIS, BRAND } from "../data/content";
import { Phone } from "lucide-react";

export default function Support() {
  return (
    <PageShell
      title="Support Center"
      intro="If you're in crisis or need immediate help, you are not alone. Please reach out to one of the trusted resources below."
    >
      <div className="rounded-3xl border border-line bg-white p-6 shadow-[0_8px_26px_rgba(47,75,57,0.05)]">
        <h2 className="font-serif text-2xl font-semibold text-heading mb-4">Crisis Resources (US)</h2>
        <ul className="space-y-4">
          {CRISIS.map((c) => (
            <li key={c.label} className="flex items-start gap-3">
              <span className="mt-0.5 flex h-9 w-9 items-center justify-center rounded-full bg-sage/12 text-sage shrink-0">
                <Phone size={16} />
              </span>
              <div>
                <p className="font-medium text-ink">{c.label}</p>
                <p className="text-sm text-sage-deep">{c.value}</p>
              </div>
            </li>
          ))}
        </ul>
        <p className="mt-5 text-sm text-ink/55">If you are outside the US or in immediate danger, please contact your local emergency number right away.</p>
      </div>

      <Block heading="Getting help within HEARD">
        <p>Crisis resources are always one tap away inside the app. Our community moderators and support tools are here to help you feel safe.</p>
      </Block>
      <Block heading="Still need us?">
        <p>Reach our team any time at <a className="text-sage-deep underline" href={`mailto:${BRAND.email}`}>{BRAND.email}</a>. We read every message with care.</p>
      </Block>
    </PageShell>
  );
}
